import type { HelpFile } from '../../types/help'
import { ValueListDetailTestIds } from '../../../testids/ValueListDetailTestIds'

export const valueListDetailHelp: HelpFile = {
  docPage: '/docs/schema/value-lists',
  texts: {
    [ValueListDetailTestIds.valueListDetailPage]:
      'Detail view of a value list — its display name, description, active flag, and the list of entries used to populate forms and validation.',
    [ValueListDetailTestIds.cardValueListDetails]:
      'Core attributes of the value list — name, description, and active state.',
    [ValueListDetailTestIds.btnAddEntry]:
      'Add a new entry to this value list. Entries appear in dropdowns and validation rules.',
    [ValueListDetailTestIds.btnDeleteList]:
      'Delete this value list. This cannot be undone — fields referencing it will fail validation.',
    [ValueListDetailTestIds.btnEditList]:
      'Edit the value list\u2019s display name, description, and active flag.',
    [ValueListDetailTestIds.colActions]: null,
    [ValueListDetailTestIds.colActive]:
      'Active entries are offered as choices in dropdowns; inactive entries are hidden from new selections.',
    [ValueListDetailTestIds.colCode]:
      'Stable machine-readable code stored when the entry is selected.',
    [ValueListDetailTestIds.colDescription]:
      'Optional description shown to users picking this entry.',
    [ValueListDetailTestIds.colDrag]:
      'Drag handle for reordering this entry within the list.',
    [ValueListDetailTestIds.colLabel]: null,
    [ValueListDetailTestIds.entriesEmpty]:
      'This value list is empty. Add entries to make it usable in forms and validation.',
    [ValueListDetailTestIds.inputEditEntryDescription]:
      'Optional description for this entry, shown to users when picking values.',
    [ValueListDetailTestIds.inputEditEntryLabel]:
      'Human-readable label for this entry, shown in dropdowns.',
    [ValueListDetailTestIds.inputEditVlDisplayName]:
      'Human-readable label for this value list.',
    [ValueListDetailTestIds.inputEditVlDescription]:
      'Optional description explaining the purpose of this value list.',
    [ValueListDetailTestIds.inputEntryCode]:
      'Stable machine-readable code stored when this entry is chosen. Cannot be changed once entries reference it.',
    [ValueListDetailTestIds.inputEntryDescription]:
      'Optional description for the new entry, shown to users when picking values.',
    [ValueListDetailTestIds.inputEntryLabel]:
      'Human-readable label for the new entry, shown in dropdowns.',
    [ValueListDetailTestIds.switchEditEntryActive]: null,
    [ValueListDetailTestIds.switchEditVlActive]: null,
  },
}
